export class NewReportContainer {
	
}
